<template>
    <div>
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWdjvwp.png" width="100%" />
        <div class="inputForm">
            <van-row>
                <van-col span="12">
                    <van-row>
                        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWdmUZK.jpg" width="90%"/>
                    </van-row>
                    <van-row>
                        <van-button round type="warning" size="small" v-clipboard:copy="'9₤EyjYX3yT5tU《 https://m.tb.cn/h.4JzqJ2L?sm=88a972  我分享给你了一个淘宝特价版商品，快来看看吧'"
                                    v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制淘口令
                        </van-button>
                    </van-row>
                </van-col>
                <van-col span="12">
                    <van-row>
                        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWdmR42.jpg" width="90%"/>
                    </van-row>
                    <van-row>
                        <van-button round type="warning" size="small" v-clipboard:copy="'9£67NYX3yhybl₴ https://m.tb.cn/h.4JzILhd?sm=270a7c  我分享给你了一个淘宝特价版商品，快来看看吧'"
                                    v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制淘口令
                        </van-button>
                    </van-row>
                </van-col>
            </van-row>
            <van-row style="margin-top:1rem;">
                <van-col span="12">
                    <van-row>
                        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWdmOOC.jpg" width="90%"/>
                    </van-row>
                    <van-row>
                        <van-button round type="warning" size="small" v-clipboard:copy="'8₴NerdX3yi6tv✔ https://m.tb.cn/h.4rGPnwC?sm=d6d3d7  我分享给你了一个淘宝特价版商品，快来看看吧'"
                                    v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制淘口令
                        </van-button>
                    </van-row>
                </van-col>
                <van-col span="12">
                    <van-row>
                        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWdmLDP.jpg" width="90%"/>
                    </van-row>
                    <van-row>
                        <van-button round type="warning" size="small" v-clipboard:copy="'1₴o54oX3yjjFt₤ https://m.tb.cn/h.4Jc8dJC?sm=49572d  我分享给你了一个淘宝特价版商品，快来看看吧'"
                                    v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制淘口令
                        </van-button>
                    </van-row>
                </van-col>
            </van-row>

            <!--<van-row style="text-align:center;margin-top:2rem;">-->
                <!--<van-col span="12">-->
                    <!--<van-button round type="warning" @click="declareVisible=true">点击复购报单</van-button>-->
                <!--</van-col>-->
                <!--<van-col span="12">-->
                    <!--<van-button round type="warning" @click="shareDialogVisible=true">点击获取海报</van-button>-->
                <!--</van-col>-->
            <!--</van-row>-->

            <div style="font-size:1.2rem;margin-top:2rem;">
                温馨提示<br/>
                完成淘宝特价版首购后，次日进入本页面<br/>
                选择任意商品，复制淘口令<br/>
                打开淘宝特价版，即可使用红包购物
            </div>
        </div>

        <van-dialog
                v-model="declareVisible"
                title="任务报单"
                show-cancel-button
                @confirm="declareOrder()"
                @cancel="closeDeclareDialog()">
            <van-cell-group style="margin-top: 1rem;">
                <van-field v-model="declareForm.orderId" label="订单号" placeholder="请输入订单号"/>
            </van-cell-group>

            <table style="width: 100%">
                <tr>
                    <td width="30%" style="text-align:center;">
                        <span>上传图片</span>
                    </td>
                    <td width="30%">
                        <div class="uploader_box">
                            <img :src="exampleImg1" @click="previewExampleImg1"/>
                        </div>
                    </td>
                    <td width="30%">
                        <div class="uploader_box">
                            <input type="file" id="logimg1" accept="image/*" @change="onRead(1)"/>
                            <img v-if="declareForm.proofImg1" :src="declareForm.proofImg1"/>
                            <img v-else :src="camera"/>
                        </div>
                    </td>
                </tr>
            </table>
        </van-dialog>

        <van-dialog v-model="shareDialogVisible" confirm-button-text="长按图片保存至本地" close-on-click-overlay>
            <img :src="shareImgSrc" width="100%"/>
        </van-dialog>

    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import {ImagePreview} from "vant";

    export default {
        data() {
            return {
                declareVisible: false,
                declareForm: {
                    jobId: null,
                    phone: '',
                    orderId: '',
                    proofImg1: '',
                    proofImg2: '',
                },
                camera: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWMQ23p.png',
                exampleImg1: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWMOZd3.png',
                shareDialogVisible: false,
                shareImgSrc: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWMZMdX.png',
            }
        },
        methods: {
            onError() {
                this.$toast.fail('复制失败')
            },
            onCopy() {
                this.$toast.success('复制成功')
            },
            onRead(type) { // 上传图片到图片服务器
                let file = document.getElementById('logimg' + type).files[0];

                let self = this;
                let reader = new FileReader();
                reader.onload = e => {
                    let result = e.target.result;
                    let formData = new FormData();
                    formData.append("dirName", "任务报单上传目录");

                    if (result.length / 1024 > 500) {
                        let img = new Image();
                        img.src = result;
                        img.onload = function () {
                            self.$toast("开始压缩图片...");
                            //0.6为压缩的程度，数值越小，压缩的文件越小，图片也会越模糊
                            let src = self.$myUtil.compressImg(img, 0.6);
                            formData.append("file", self.$myUtil.base64ImgDataToFile(src, file.name));
                            self.uploadImg(formData, type);
                        }
                    } else {
                        formData.append("file", file);
                        self.uploadImg(formData, type);
                    }
                };
                // 读取图像
                reader.readAsDataURL(file);
            },
            //上传图片
            uploadImg(formData, type) {
                this.$toast("开始上传图片...");
                this.$http.post('/sys/ossFileMapping/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (1 === type) {
                        this.declareForm.proofImg1 = res.data; //这里上传到指定的图片服务器，成功后会返回图片的url
                    } else if (2 === type) {
                        this.declareForm.proofImg2 = res.data;
                    }
                    this.$toast("图片上传成功");
                }).catch(() => {
                    this.$toast("图片上传失败");
                })
            },
            previewExampleImg1() {
                ImagePreview([
                    this.exampleImg1,
                ]);
            },
            declareOrder() {
                if (!this.declareForm.orderId) {
                    this.$toast("请先填写订单号");
                    return;
                }
                // if (!this.declareForm.phone) {
                //     this.$toast("请先填写手机号");
                //     return;
                // }
                if (!this.declareForm.proofImg1) {
                    this.$toast("请先上传凭证");
                    return;
                }
                // if (!this.declareForm.proofImg2) {
                //     this.$toast("请先上传凭证");
                //     return;
                // }
                this.declareForm.jobId = 88;
                mainAPI.jobOrderDeclare(this.declareForm).then(() => {
                    this.closeDeclareDialog();
                    this.$toast("报单成功");
                }).catch(() => {
                });
            },
            closeDeclareDialog() {
                this.declareForm.phone = '';
                this.declareForm.orderId = '';
                this.declareForm.proofImg1 = '';
                this.declareVisible = false;
            },
        }
    }

</script>

<style lang="scss" scoped>

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        padding: 1rem;
        text-align: center;
    }

    .uploader_box {
        width: 7rem;
        height: 11rem;
        overflow: hidden;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }
    }

    #logimg1 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }


</style>
